import { Radio } from 'lucide-react';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import type { PluginWiring } from './types';
import { WebhookWiringCard } from './WebhookWiringCard';

export function PluginWebhookSection({ wirings }: { wirings: PluginWiring[] }) {
  if (wirings.length === 0) return null;

  return (
    <section data-testid="plugin-detail-section-webhooks">
      <IconSectionHeader icon={Radio}>Webhook Wiring</IconSectionHeader>
      <div className="space-y-3">
        {wirings.map((w) => (
          <WebhookWiringCard key={`${w.role}-${w.source}`} wiring={w} />
        ))}
      </div>
    </section>
  );
}
